import React from "react";
import { useRoutes } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { baseTheme } from "./assets/global/Theme-variable";
import Themeroutes from "./routes/Router";
import "./assets/css/app.css";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./queryClient";
import SuccessSnackbar from "./components/AppComponents/SnackBar";
import { SnackbarProvider } from "./components/AppComponents/SnackBarProvider";

const App = () => {
  const routing = useRoutes(Themeroutes);
  const theme = baseTheme;
  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider>
        <QueryClientProvider client={queryClient}>
          {routing}
        </QueryClientProvider>
        <SuccessSnackbar />
      </SnackbarProvider>
    </ThemeProvider>
  );
};

export default App;
